import { IVideoPlayerProps } from '@/types/VideoPlayerProps';
import { styled } from '@mui/material';

export const VideoWrapper = styled('div')<{ ratio: number }>`
  position: relative;
  display: flex;
  overflow: hidden;
  margin-bottom: ${({ theme }) => theme.spacing(5)};
  border-radius: 20px;
  overflow: hidden;
  grid-area: image;
  padding-top: ${({ ratio }) => ratio}%;
  width: 100vw;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: 100%;
  }
`;

export const Video = styled('div')<IVideoPlayerProps>`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
`;
